<template>
    <div class="test">
        <div v-for="(item,index) in data" :key="index">
            <p>	
                {{index+1}}、{{item.question}}
            </p>
            <span v-for="(items,indexs) in item.options" :key="indexs">
                <input type="radio" :disabled="submitStatus" :name="'radio'+index" :value="indexs" v-model="options[index]" :id="'radio'+index+indexs"/>
                <label :for="'radio'+index+indexs">
                        {{items}}
                </label>
            </span>
        </div>
        <button v-if="data.length>0" @click="submit">提交</button>
        <span v-if="submitStatus" style="color:#f56c6c;font-size:30px">获得分数：{{pass}}</span>
        <!-- <span v-if="submitStatus&!pass" style="color:#67c23a">很遗憾您未通过考核</span> -->
    </div>
</template>

<script>
import {
  getExamQuestions,
  examine
} from "@/assets/js/axios.js";
export default {
    name: "test",
    data(){
        return{
            data:[],
            options:[],
            submitStatus:false,
            pass:false,
        }
    },
    created(){
        getExamQuestions(this.$route.params.id.substring(0, this.$route.params.id.length - 4))
        .then(res => {
            if(res.code==1){
                this.data=res.data
            }else{
                this.$message({
                    message: res.data,
                    type: 'error'
                });
            }
        })
    },
    methods:{
      
        submit(){
            if(this.submitStatus){
                return
            }
            let obj=[]
            let rightNum=0;
            var div=document.querySelectorAll(".test div");
            for(let i=0;i<this.options.length;i++){
                if(this.options[i]){
                    obj.push({qid:this.data[i].qid,answer:this.options[i]})
                }
            }
            if(obj.length<this.data.length){
                this.$message({
                    message: '请全部作答完毕再提交',
                    type: 'warning'
                });
                return
            }
            
            examine(obj).then(res=>{
                if(res.code==1){
                    this.submitStatus=true
                    function toInt(char){
                        let int=4;
                        switch (char){
                            case "A":
                                int=0;
                                break;
                            case "B":
                                int=1;
                                break;
                            case "C":
                                int=2;
                                break;
                            case "D":
                                int=3;
                                break;
                        }
                        return int;
                    }
                    for(let i=0;i<this.options.length;i++){
                        var span=div[i].querySelectorAll("span")
                        if(this.options[i]==this.data[i].rightAnswer){
                            span[toInt(this.options[i])].style.color="#67c23a"
                            rightNum++;
                        }else{
                            span[toInt(this.data[i].rightAnswer)].style.color="#f56c6c"
                        }
                    }
                    this.pass=parseInt(rightNum/this.data.length*100);
                    // this.pass=res.data.pass
                    // if(res.data.pass){
                    //     this.$message({
                    //         message: '恭喜您通过考核',
                    //         type: 'success'
                    //     });
                    // }else{
                    //     this.$message({
                    //         message: '很遗憾您未通过考核',
                    //         type: 'error'
                    //     });
                    // }
                }else{
                    this.$message({
                        message: '提交遇到错误，请重试',
                        type: 'error'
                    });
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.test{
    padding:60px 0 40px;
    width: 1200px;
    margin: 0 auto;
    div{
       
        margin: 20px 0;
        line-height: 40px;
        span{
            padding-left:28px;
        }
    }
    button{
        margin: 30px;
        width: 160px;
        height: 40px;
        cursor: pointer;
        background: #109eff;
        border:none;
        color: #fff;
        border-radius: 8px;
        outline: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/test.vue